import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Container } from "react-bootstrap";
import { apiRequest } from "../components/Config";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("getpossibilities", "GET");
        if (Array.isArray(response)) {
          setOptions(response);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  const groupedOptions = options.reduce((acc, item) => {
    if (!acc[item.groupname]) {
      acc[item.groupname] = [];
    }
    acc[item.groupname].push(item);
    return acc;
  }, {});

  return (
    <div>
      <VN userData={userData} />

      <Container style={{ marginTop: "40px" }}>
        <Typography variant="h3" sx={{ marginBottom: 4 }}>
          Usługi
        </Typography>

        {Object.entries(groupedOptions).map(([groupName, items]) => (
          <Box key={groupName} sx={{ marginBottom: 5 }}>
            <Typography
              variant="h5"
              sx={{
                marginBottom: 2,
                fontWeight: 600,
              }}
            >
              {groupName}
            </Typography>

            {items.map((item) => (
              <Box
                key={item.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  padding: "6px 0",
                  transition: "0.2s",
                  "&:hover": {
                    transform: "translateX(3px)",
                  },
                }}
              >
                <TaskAltIcon
                  sx={{
                    color: "success.main",
                    fontSize: 20,
                  }}
                />

                <Typography variant="body1">{item.activity}</Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Container>
    </div>
  );
}
